// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.q-container {
  margin: 2px;
  padding: 2px;
  border-radius: 5px;
}
.q-container .q-text {
  margin: 2px;
}
.q-container .legend {
  margin-left: 10px;
  color: grey;
  font-style: italic;
}
.q-container .q-title {
  font-weight: 500;
}
.q-container .label-question-container {
  align-items: left;
  width: 100%;
  flex-direction: column;
}
.q-container .clickable {
  cursor: pointer;
  color: var(--primary-color) !important;
  font-weight: 600;
}
.q-container .footer-question {
  padding-top: 15px;
  padding-bottom: 15px;
}
.q-container .custom-tooltip {
  max-width: 400px;
  padding: 20px;
}
.q-container .header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.q-container .header-content {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.q-container .left-content {
  display: flex;
}
.q-container .flex-item-1 {
  margin-right: 50px;
}
.q-container .centered-content {
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/main/apps/measure/question/question.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AACJ;AACI;EACI,WAAA;AACR;AAEI;EACI,iBAAA;EACA,WAAA;EACA,kBAAA;AAAR;AAGI;EACI,gBAAA;AADR;AAKI;EACI,iBAAA;EACA,WAAA;EACA,sBAAA;AAHR;AAMI;EACI,eAAA;EACA,sCAAA;EACA,gBAAA;AAJR;AAOI;EACI,iBAAA;EACA,oBAAA;AALR;AAQI;EACI,gBAAA;EACA,aAAA;AANR;AASI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAPR;AAUI;EACI,aAAA;EACA,8BAAA;EACA,WAAA;AARR;AAWI;EACI,aAAA;AATR;AAYI;EACI,kBAAA;AAVR;AAaI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAXR","sourcesContent":[".q-container {\n    margin: 2px;\n    padding: 2px;\n    border-radius: 5px;\n\n    .q-text {\n        margin: 2px;\n    }\n\n    .legend {\n        margin-left: 10px;\n        color: grey;\n        font-style: italic;\n    }\n\n    .q-title {\n        font-weight: 500;\n    }\n\n\n    .label-question-container {\n        align-items: left;\n        width: 100%;\n        flex-direction: column;\n    }\n\n    .clickable {\n        cursor: pointer;\n        color: var(--primary-color) !important;\n        font-weight: 600;\n    }\n\n    .footer-question {\n        padding-top: 15px;\n        padding-bottom: 15px;\n    }\n\n    .custom-tooltip {\n        max-width: 400px;\n        padding: 20px;\n    }\n\n    .header-content {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n    }\n\n    .header-content {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n    }\n\n    .left-content {\n        display: flex;\n    }\n\n    .flex-item-1 {\n        margin-right: 50px;\n    }\n\n    .centered-content {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
